/* eslint-disable */
export default {
  mute: '靜音',
  unmute: '取消靜音',
  hangup: '掛斷',
  reject: '拒絕',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
